import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatToolbar } from '@angular/material/toolbar'
import { ActivatedRoute, Router } from '@angular/router'
import { firstValueFrom, map } from 'rxjs'
import { UsersService } from '../users.service'
import { AsyncPipe, Location } from '@angular/common'
import { LoggerService } from '../logger.service'

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatIcon, MatIconButton, MatToolbar, AsyncPipe],
  templateUrl: './toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  @Input()
  title = ''

  @Input()
  backButtonLink: string[] | null = null

  @Input()
  showAdminButton = false

  router = inject(Router)
  route = inject(ActivatedRoute)
  usersService = inject(UsersService)
  location = inject(Location)
  currentUser$ = this.usersService.currentUser$
  logger = inject(LoggerService)
  callId$ = this.route.paramMap.pipe(map((params) => parseInt(params.get('id')!)))

  navigateToAdminView() {
    firstValueFrom(this.callId$).then((callId) => {
      if (!Number.isNaN(callId)) {
        const url = this.router.serializeUrl(this.router.createUrlTree(['/app', 'admin', 'meetings', callId]))
        window.open(url, '_blank')
      }
    })
  }

  goBack() {
    if (document.referrer === '') {
      this.logger.debug('No referrer found, redirecting to calls')
      this.router.navigate(this.backButtonLink!)
      return
    }
    this.logger.debug(`Referer found. Going back to ${document.referrer}`)
    this.location.back()
  }
}
